export const app = {
  version: '1.5.4',
};
